import { FC } from 'react';
import classNames from 'classnames';
import storyTimelineCss from '../assets/story-timeline.module.scss';

type PropsType = {
  activeIndex: number;
  currentIndex: number;
  progress: number;
};

const StoryDetailListTimelineItem: FC<PropsType> = ({
  activeIndex,
  currentIndex,
  progress,
}) => (
  <div
    className={classNames(
      storyTimelineCss.storyTimeline__item,
      { [storyTimelineCss.storyTimeline__item_complete]: currentIndex < activeIndex },
      { [storyTimelineCss.storyTimeline__item_withProgress]: currentIndex === activeIndex },
    )}
    // @ts-ignore
    style={{ '--story-timeline-progress': `${progress}%` }}
  />
);

export { StoryDetailListTimelineItem };
